export interface IAddGroupingMemberRequest {
    token: string;
    legalcompanyName: string;
    operatingName: string;
    address: string;
    city: string;
    country: string;
    province: string;
    postalCode: string;
    mainPhone: string;
    discountsQuestion: string;
    accountingName: string;
    accountingPhone: string;
    accountingEmail: string;
    groupMemberLocations: string;
}

export interface INewMemberLocationForm {
    id: number;
    legalcompanyName: string;
    operatingName: string;
    address: string;
    city: string;
    country: string;
    province: string;
    postalCode: string;
    mainPhone: string;
    discountsQuestion: string;
}

export interface INewMemberProfileForm {
    legalcompanyName: string;
    operatingName: string;
    address: string;
    city: string;
    country: string;
    province: string;
    postalCode: string;
    mainPhone: string;
    discountsQuestion: string;
    accountingName: string;
    accountingPhone: string;
    accountingEmail: string;
}

export interface INewSupplierProfileForm {
    token: string;
    companyName: string;
    address: string;
    city: string;
    country: string;
    province: string;
    postalCode: string;
    mainPhone: string;
    financialInstitution: string;
    bankingAddress: string;
    bankingCity: string;
    bankingProvince: string;
    bankingPostalCode: string;
    bankingPhone: string;
    routingNumber: string;
    accountNumber: string;
    accountingName: string;
    accountingPhone: string;
    accountingEmail: string;
}

export interface IGroupLinkValidationResponse {
    status?: string;
  }

export class GroupToken {
    public token: string;
}

export interface IDropDown {
    label: string;
    value: any;
    code?: string;
}

export interface IConfigCountry {
    countryCode: string;
    countryName: string;
    languageCode: string;
    isVisible: true;
}

export interface IConfigProvince {
    provinceCode: string;
    countryCode: string;
    languageCode: string;
    provinceName: string;
}
